import { FC, memo } from 'react';
import { DayPicker } from 'react-day-picker';
import { Box } from '@chakra-ui/react';

import { DatePickerPopoverProps } from './types/DatePickerPopoverProps';

const DatePickerPopoverComponent: FC<DatePickerPopoverProps> = ({
  startMonth,
  endMonth,
  visibleMonth,
  setVisibleMonth,
  setDate,
  selectedDate,
}) => (
  <Box boxShadow="0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);">
    <DayPicker
      captionLayout="dropdown"
      defaultMonth={visibleMonth}
      endMonth={endMonth}
      mode="single"
      month={visibleMonth}
      onMonthChange={setVisibleMonth}
      onSelect={setDate}
      required
      selected={selectedDate}
      showOutsideDays={false}
      startMonth={startMonth}
    />
  </Box>
);

export const DatePickerPopover = memo(DatePickerPopoverComponent);
